<template>
    <div class="Administration">
        <el-form
            :model="ruleForm"
            ref="ruleForm"
            label-width="100px"
            style="overflow: hidden;"
            class="demo-ruleForm"
        >
        <el-row>
            <el-col :span="5">
                <el-form-item label="开始日期" prop="startString">
                    <el-date-picker
                        @change="startTime1"
                        v-model="ruleForm.startString"
                        align="right"
                        type="date"
                        placeholder="选择开始日期"
                        format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="5">
                <el-form-item label="结束日期" prop="endString">
                    <el-date-picker
                        @change="endTime1"
                        v-model="ruleForm.endString"
                        align="right"
                        type="date"
                        placeholder="选择结束日期"
                        format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="5">
                <el-form-item label="还款状态" prop="state">
                    <el-select v-model="ruleForm.state" placeholder="请选择">
                        <el-option
                            v-for="item in stateList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-col>

            <el-col :span="5">
                <el-form-item label="信用卡持有人" prop="cardholderName">
                    <el-select v-model="ruleForm.cardholderName" placeholder="请选择">
                        <el-option
                            v-for="item in manList"
                            :key="item"
                            :label="item"
                            :value="item"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-col>

            <el-col :span="5">
                <el-form-item label="开户行" prop="bankName">
                    <el-select v-model="ruleForm.bankName" placeholder="请选择">
                        <el-option
                            v-for="item in bankList"
                            :key="item"
                            :label="item"
                            :value="item"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-col>

            <el-col :span="5">
                <el-form-item label="账单日" prop="billDate">
                    <el-select v-model="ruleForm.billDate" placeholder="请选择">
                        <el-option v-for="item in 31" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>

            <el-col :span="5">
                <el-form-item label="还款日" prop="repaymentDate">
                    <el-select v-model="ruleForm.repaymentDate" placeholder="请选择">
                        <el-option v-for="item in 31" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>

        </el-row>
            <!-- <el-col :span="7" class="line-height4">
        <el-col :span="5">搜索类型：</el-col>
        <el-col :span="18">
          <span
            class="Detailedspan"
            v-for="(item,i) in currency"
            :key="i"
            @click="Choice(item.val)"
            :class="{active : Choicetype === item.val}"
          >{{item.name}}</span>
        </el-col>
            </el-col>-->
            <el-col :span="11">
                <el-form-item prop="searchInput">
                    <el-input
                        v-model="ruleForm.searchInput"
                        placeholder="全字段搜索"
                        style="width: 70%;margin-left:0px!important;"
                    ></el-input>
                    <el-button type="primary" style="margin-left:15px;" @click="getCreditCardRepaymentList()">搜索</el-button>
                    <el-button type="primary" @click="resetFprm('ruleForm')">重置</el-button>
                </el-form-item>
            </el-col>
            
        </el-form>
        <el-row>
            <el-table :data="tableData" :header-cell-style="headClass" border style="width: 100%">
                <el-table-column prop="name" label="信用卡持有人" align="center">
                    <template slot-scope="scope">
                        <p>{{scope.row.cardholderName}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="Cardnumber" label="信用卡号" width="260" align="center">
                    <template slot-scope="scope">
                        <p>{{scope.row.bankNumber}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="Bank" label="开户银行" align="center">
                    <template slot-scope="scope">
                        <p>{{scope.row.bankName}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="bill" label="账单日" align="center">
                    <template slot-scope="scope">
                        <p>{{scope.row.billDate}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="repayment" label="还款日" align="center">
                    <template slot-scope="scope">
                        <p>{{scope.row.repaymentDate}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="绑定店铺" align="center">
                    <!-- <template slot-scope="scope">
            <el-collapse v-for="(ele,i) in scope.row.shopList" :key="i">
              <el-collapse-item :title="ele.shop">
                <div class="line-height" v-for="(item,i) in ele.station" :key="i">{{item}}</div>
              </el-collapse-item>
            </el-collapse>
                    </template>-->
                    <template slot-scope="scope">
                        <p>{{scope.row.shopName}}</p>
                    </template>
                </el-table-column>
                <el-table-column align="center">
                    <template slot="header" slot-scope="scope">
                        预还款金额
                        <el-popover trigger="hover" placement="top">
                            <p>该金额为当前汇率转换的人民币数额</p>
                            <i class="iconfont icon-tishi" slot="reference"></i>
                        </el-popover>
                    </template>
                    <!-- <template slot-scope="scope">{{scope.row.Advance_repayment}}</template> -->
                    <template slot-scope="scope">
                        <p>{{scope.row.originalTotalCny}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="Actual_repayment" label="实还款金额" align="center">
                    <template slot-scope="scope">
                        <p>{{scope.row.repayAmount}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="Difference" label="差额" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.repayAmount != null">
                            <p>{{(scope.row.originalTotalCny+scope.row.repayAmount).toFixed(2)}}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="Difference" label="还款状态" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.repaymentStatus == 1" style="color:red;">未还款</span>
                        <span v-if="scope.row.repaymentStatus == 2">已还款</span>
                    </template>
                </el-table-column>
                <el-table-column prop="time" label="交易时间" width="160" align="center">
                    <template slot-scope="scope">
                        <p>{{scope.row.fundtransferdate}}</p>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="160" align="center">
                    <template slot-scope="scope">
                        <el-button
                            v-if="scope.row.repaymentStatus == '1'"
                            type="success"
                            @click="Detailed(scope.row)"
                        >还款</el-button>
                        <el-button
                            v-if="scope.row.repaymentStatus == '2'"
                            type="primary"
                            @click="Details(scope.row)"
                        >详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    style="margin-right:200px;"
                    layout="total, sizes, prev, pager, next, jumper"
                    :page-sizes="[5, 10, 20, 50]"
                    :page-size="pagesize"
                    :current-page="currentPage"
                    :total="total"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                ></el-pagination>
            </div>
        </el-row>
        <Xykrepayment ref="Xykrepayment" />
        <Detailed ref="Detailed" @refresh="refresh" />
        <Details ref="Details" />
    </div>
</template>

<script>
import Xykrepayment from "./repaymentframe/Xykrepayment";
import Detailed from "./repaymentframe/Detailed";
import Details from "./repaymentframe/details";
import { ajaxPost, Baseurl } from "../../../api/api/api";
export default {
    name: "repayment",
    components: {
        Xykrepayment,
        Detailed,
        Details
    },
    data() {
        return {
            headClass: this.common.headClass,
            Choicetype: "0",
            tableData: [],
            ruleForm: {
                startString: "",
                endString: "",
                state: "",
                searchInput: "",
                billDate:"",
                repaymentDate:"",
                cardholderName:"",
                bankName:"",
            },
            manList:[],
            bankList:[],
            stateList: [
                {
                    value: "1",
                    label: "未还款"
                },
                {
                    value: "2",
                    label: "已还款"
                }
            ],
            currency: [
                {
                    val: "0",
                    name: "全部"
                },
                {
                    val: "1",
                    name: "账单日"
                },
                {
                    val: "2",
                    name: "还款日"
                },
                {
                    val: "3",
                    name: "交易时间"
                }
            ],
            currentPage: 1,
            pagesize: 50,
            size: 100,
            total: 0,
        };
    },
    mounted() {},
    created() {
        this.getCreditCardRepaymentList();
        this.CardManAjax();
        this.BankAjax();
    },
    methods: {
        refresh() {
            this.getCreditCardRepaymentList();
        },
        CardManAjax(){
            ajaxPost(Baseurl + "creditCardController/getCardholderNameList").then(res => {
                this.manList = res.data.data;
            });
        },
        BankAjax(){
            ajaxPost(Baseurl + "creditCardController/getBankNameList").then(res => {
                this.bankList = res.data.data;
            });
        },
        getCreditCardRepaymentList() {
            var role = JSON.parse(window.localStorage.getItem("role"));
            var parameter = {
                page: this.currentPage,
                size: this.size,
                companyId: role.company_id,
                searchStr: this.ruleForm.searchInput,
                startString: this.ruleForm.startString,
                endString: this.ruleForm.endString,
                repaymentStatus: this.ruleForm.state,
                cardholderName: this.ruleForm.cardholderName,
                bankName: this.ruleForm.bankName,
                billDate: this.ruleForm.billDate,
                repaymentDate: this.ruleForm.repaymentDate,
            };
            ajaxPost(
                Baseurl + "creditCardController/getCreditCardRepaymentList",
                parameter
            ).then(res => {
                this.tableData = res.data.data.list;
                this.total = res.data.data.total;
            });
        },
        startTime1(val) {
            var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate() +
                " 00:00:00";
            this.ruleForm.startString = datetime;
        },
        endTime1(val) {
            var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate() +
                " 23:59:59";
            this.ruleForm.endString = datetime;
        },
        resetFprm(formName) {
            this.$refs[formName].resetFields();
            this.getCreditCardRepaymentList();
        },
        Choice(val) {
            this.Choicetype = val;
        },
        Detailed(e) {
            this.$refs.Detailed.init(e);
        },
        Details(e) {
            this.$refs.Details.init(e);
        },
        handleSizeChange(val) {
            this.size = val;
            this.getCreditCardRepaymentList()
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getCreditCardRepaymentList()
        },
    }
};
</script>

<style lang="scss" scoped>
/deep/ {
    .el-collapse {
        border-top: 1px solid #fff;
        border-bottom: 1px solid #fff;
    }
    .el-collapse-item__header {
        border-bottom: 1px solid #fff;
    }
    .el-collapse-item__wrap {
        border-bottom: 1px solid #fff;
    }
    .el-collapse-item__content {
        padding-bottom: 0px;
    }
}
.line-height {
    line-height: 30px;
}
.line-height4 {
    line-height: 40px;
}
.Detailedspan {
    margin-right: 5px;
    padding: 2px 8px;
    border-radius: 4px;
}
.active {
    background-color: rgb(43, 110, 236);
    color: #fff;
}
.page {
        position: fixed;
        width: 100%;
        bottom: 0;
        background-color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
        z-index: 99;
    }
</style>